import { GetStaticPaths, GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { TermsPage } from '@/pages/Terms';
import { deviceType } from '@/shared/constants';
import { getPaths, parseSSGParams } from '@/shared/helpers';
import { i18n } from '../../../next-i18next.config';

export const getStaticProps: GetStaticProps = async (context) => {
  const { device } = parseSSGParams(context.params);

  const isValidPath = Object.values(deviceType).includes(device);
  if (!isValidPath) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(context.locale || i18n.defaultLocale, ['common'])),
    },
  };
};

export const getStaticPaths: GetStaticPaths = async (_context) => {
  return {
    paths: getPaths(),
    fallback: 'blocking',
  };
};

export default TermsPage;
